import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
  TextField,
  Grid,
  MenuItem,
} from "@mui/material";
import styles from "../../screens/InternalTracker/InternalTracker.module.css";
import { PiFileTextLight } from "react-icons/pi";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { chnageStatusOfCandidate } from "../../redux/post-requirement/postRequirementSlice";
import { openResume, whichStatus } from "../../utils/const";
import { getOneSubmissionTracker } from "../../redux/internal-tracking/InternalSubmissionSlice";
import { useFormik } from "formik";
import * as Yup from "yup";
import { mode_of_interview } from "../../utils/const2";
import { RxCross2 } from "react-icons/rx";
import InterviewStatusdrawer from "../../screens/InternalTracker/Requirements/InterviewStatusDrawer";

const today = new Date().toISOString().split("T")[0]; // Today's date in YYYY-MM-DD format
const maxDate = new Date();
maxDate.setDate(maxDate.getDate() + 30); // Maximum date is 30 days from today
const maxDateStr = maxDate.toISOString().split("T")[0];

const statusList = [
  { key: "INTERNAL_SUBMISSION", label: "Submitted" },
  { key: "ECI_SUBMISSION", label: "Eci Submission" },
  { key: "EC_SUBMISSION", label: "Ec Submission" },
  { key: "1st_ROUND_OF_INTERVIEW", label: "1st round intro" },
  { key: "2nd_ROUND_OF_INTERVIEW", label: "2nd round intro" },
  { key: "3rd_ROUND_OF_INTERVIEW", label: "3rd round intro" },
  { key: "OFFER_CONFIRMATION", label: "Offer Confirmation" },
  { key: "REJECTED", label: "Rejected" },
];

const SalesRecruiter = ({
  image,
  name,
  skill,
  phoneno,
  email,
  btn2,
  res,
  row,
  type,
  viewData,
}) => {
  const [open, setOpen] = useState(false);
  const [btn1, setBtn1] = useState(""); // Initial text for btn1
  const [getSelectedIndexName, setGetSelectedIndexName] = useState("");
  const [inputType, setInputType] = useState("text");
  const [isStatusChange, setIsStatusChange] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const handleCloseShowStatus = () => setShowStatus(false);
  const handleShowStatus = () => setShowStatus(true);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const requirementStatus = useSelector(
    (state) => state.postrequirement.status
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Function to handle dropdown item click
  const handleSelect = (text) => {
    setBtn1(text); // Update btn1 text
    // handleClickOpen();
    handleShowStatus();
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnClickStatusChange = () => {
    let userData = {
      candidate_status: btn1,
      requirement_candidate_tracker: res?.id,
      // interview_time:"",
      // mode_of_interview:"",
      // documentation:"",
      // rejection_reason:"",
      // feedback:""
    };
    let id = res?.id;
    dispatch(chnageStatusOfCandidate({ userData, id }));
    setIsStatusChange(true);
  };

  useEffect(() => {
    if (requirementStatus === "change_candidate_status" && isStatusChange) {
      setIsStatusChange(false);
      let id = row?.requirement_id;
      dispatch(getOneSubmissionTracker(id));
      handleClose();
    }
  }, [requirementStatus]);

  useEffect(() => {
    setBtn1(res?.progress[0]?.candidate_status);
    setGetSelectedIndexName(res?.progress[0]?.candidate_status);
  }, [res]);

  const formik = useFormik({
    initialValues: {
      interview_mode: null,
      interview_date: null,
      interview_time: null,
      point_of_contact: null,
      interview_note: null,
      client_name: null,
    },
    validationSchema: Yup.object({
      interview_mode: Yup.string().required("Interview Mode is required"),
      interview_date: Yup.date().min(
        new Date(today),
        "Date cannot be in the past"
      ),
    }),
    onSubmit: (values) => {
    },
  });

  const autoResize = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto"; // Reset the height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set it to match content
    }
  };

  const getSelectedIndex = () =>
    statusList.findIndex((item) => item.key === getSelectedIndexName);

  return (
    <Box
      className={styles.recruiter_job_post}
      sx={{ border: "1px solid #f5f5f5" }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {/* <img src={image} alt="" /> */}
        <span>
          <Typography>
          Candidate Name: <b>{name}</b>
          </Typography>
          <Typography>
            Job Profile: <b>{skill}</b>
          </Typography>
          <Typography>
            Phone No: <b>{phoneno}</b>
          </Typography>
          <Typography sx={{ margin: "0 !important" }}>
            Email ID: <b>{email}</b>
          </Typography>
        </span>
      </Box>

      <Box
        sx={{ alignItems: "center", flexDirection: "column", display: "flex" }}
      >
        <a
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "35px",
            justifyContent: "space-between",
            alignSelf: "flex-start",
            textDecoration: "none",
            color: "#374151",
          }}
          href={res?.resume}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Typography>
            <PiFileTextLight fontSize="26px" /> <b>Open Resume</b>
          </Typography>
        </a>
        <span style={{ alignSelf: "flex-end" }}>
          <div className="btn-group">
            <button
              type="button"
              className="dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style={{ color: "black", width: "7rem" }}
            >
              {/* {whichStatus(btn1)} */}
              {statusList.find((item) => item.key === btn1)?.label ||
                "Select Status"}
            </button>
            {/* <div className="dropdown-menu">
              <a
                className="dropdown-item"
                style={{ backgroundColor: "#fff" }}
                onClick={() => handleSelect("INTERNAL_SUBMISSION")}
              >
                Submitted
              </a>
              <a
                className="dropdown-item"
                style={{ backgroundColor: "#fff" }}
                onClick={() => handleSelect("Ec Submission")}
              >
                Client Submission
              </a>

              <a
                className="dropdown-item"
                style={{ backgroundColor: "#fff" }}
                onClick={() => handleSelect("Eci Submission")}
              >
                End Client Submission
              </a>

              <a
                className="dropdown-item"
                style={{ backgroundColor: "#fff" }}
                onClick={() => handleSelect("1st_ROUND_OF_INTERVIEW")}
              >
                1st Round Interview
              </a>
              <a
                className="dropdown-item"
                style={{ backgroundColor: "#fff" }}
                onClick={() => handleSelect("2nd_ROUND_OF_INTERVIEW")}
              >
                2nd Round Interview
              </a>
              <a
                className="dropdown-item"
                style={{ backgroundColor: "#fff" }}
                onClick={() => handleSelect("3rd_ROUND_OF_INTERVIEW")}
              >
                3rd Round Interview
              </a>
              <a
                className="dropdown-item"
                style={{ backgroundColor: "#fff" }}
                onClick={() => handleSelect("offer confirmation")}
              >
                Offer Confirmation
              </a>
              <a
                className="dropdown-item"
                style={{ backgroundColor: "#fff" }}
                onClick={() => handleSelect("Rejected")}
              >
                Rejected
              </a>
            </div> */}
            <div className="dropdown-menu">
              {statusList.map((item, index) => (
                <a
                  key={item.key}
                  className={`dropdown-item ${
                    index <= getSelectedIndex() ? styles.disabled : ""
                  }`}
                  onClick={() =>
                    index > getSelectedIndex() && handleSelect(item.key)
                  }
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
          <button
            onClick={() => {
              navigate("/requirement-tracker-view-details", {
                state: { res: res, row: row, type: type },
              });
              localStorage.setItem(
                "internalSubmissionCandidateDetails",
                JSON.stringify({
                  row,
                  type,
                  res,
                })
              );
            }}
            style={{
              backgroundColor: "#f0f0f0",
              marginLeft: "10px",
              width: "6rem",
            }}
          >
            {btn2}
          </button>
        </span>
      </Box>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        // onClose={handleClose}
        maxWidth="md"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogContent sx={{ textAlign: "center" }}>
            <Box
              sx={{
                textAlign: "start",
                marginLeft: "5px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <span>
                <Typography>
                  Requirement from: <b>{viewData?.bdm_name}</b>
                </Typography>
                {viewData?.client_name === "" ||
                viewData?.client_name === undefined ||
                viewData?.client_name === null ? (
                  ""
                ) : (
                  <Typography>
                    Client Name: <b>{viewData?.client_name}</b>
                  </Typography>
                )}
              </span>
              <span>
                <RxCross2
                  style={{
                    color: "#eb4848",
                    fontSize: "22px",
                    cursor: "pointer",
                  }}
                  onClick={handleClose}
                />
              </span>
            </Box>
            <form onSubmit={formik.handleSubmit}>
              <Grid container>
                {(viewData?.client_name === "" ||
                  viewData?.client_name === undefined ||
                  viewData?.client_name === null) && (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    sx={{ padding: "10px" }}
                  >
                    <TextField
                      variant="standard"
                      label="Client Name"
                      sx={{ width: "100%" }}
                      name="client_name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.client_name}
                    />
                  </Grid>
                )}

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "10px" }}
                >
                  <TextField
                    variant="standard"
                    label="Point of Contact"
                    sx={{ width: "100%" }}
                    name="point_of_contact"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.point_of_contact}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "10px" }}
                >
                  <TextField
                    select
                    variant="standard"
                    label="Interview Mode"
                    sx={{ width: "100%" }}
                    name="interview_mode"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.interview_mode}
                  >
                    {mode_of_interview.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  {formik.touched.interview_mode &&
                  formik.errors.interview_mode ? (
                    <div className={styles.error}>
                      {formik.errors.interview_mode}
                    </div>
                  ) : null}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "10px" }}
                >
                  <TextField
                    variant="standard"
                    label="Interview Date"
                    type={inputType}
                    sx={{ width: "100%" }}
                    name="interview_date"
                    onChange={formik.handleChange}
                    onBlur={(e) => {
                      formik.handleBlur(e);
                      setInputType("text");
                    }}
                    onClick={() => setInputType("date")}
                    inputProps={{
                      max: today,
                    }}
                    value={formik.values.interview_date}
                    error={
                      formik.touched.interview_date &&
                      Boolean(formik.errors.interview_date)
                    }
                    helperText={
                      formik.touched.interview_date &&
                      formik.errors.interview_date
                    }
                  />

                  {formik.touched.interview_date &&
                  formik.errors.interview_date ? (
                    <div className={styles.error}>
                      {formik.errors.interview_date}
                    </div>
                  ) : null}
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{ padding: "10px" }}
                >
                  <TextField
                    variant="standard"
                    label="Interview Time"
                    type={inputType}
                    sx={{ width: "100%" }}
                    name="interview_time"
                    onChange={formik.handleChange}
                    onBlur={(e) => {
                      formik.handleBlur(e);
                      setInputType("text");
                    }}
                    onClick={() => setInputType("date")}
                    inputProps={{
                      min: today,
                      max: maxDateStr,
                    }}
                    value={formik.values.interview_time}
                    error={
                      formik.touched.interview_time &&
                      Boolean(formik.errors.interview_time)
                    }
                    helperText={
                      formik.touched.interview_time &&
                      formik.errors.interview_time
                    }
                  />

                  {formik.touched.interview_time &&
                  formik.errors.interview_time ? (
                    <div className={styles.error}>
                      {formik.errors.interview_time}
                    </div>
                  ) : null}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{
                    padding: "10px",
                    border: "1px solid #949494",
                    borderRadius: "3px",
                    margin: "10px",
                  }}
                >
                  <textarea
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="4"
                    placeholder="Interview Note"
                    name="interview_note"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.interview_note}
                    onInput={(event) => autoResize(event.target)}
                    ref={(el) => el && autoResize(el)}
                    style={{
                      overflow: "hidden",
                      resize: "none",
                      border: "none",
                    }}
                  ></textarea>
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <Box>
            <Box
              className={styles.adding_internal_btns}
              sx={{ margin: "10px 0 15px" }}
            >
              <button
                style={{ backgroundColor: "#4287f5 !important" }}
                // onClick={handleOnClickStatusChange}
                onClick={formik.handleSubmit}
              >
                Submit
              </button>
            </Box>
          </Box>
        </Box>
      </Dialog>
      <InterviewStatusdrawer
        handleShow={handleShowStatus}
        handleClose={handleCloseShowStatus}
        show={showStatus}
        viewData={viewData}
        res={res}
        row={row}
        statusName={btn1}
      />
    </Box>
  );
};

export default SalesRecruiter;
